export default __webpack_public_path__ + "static/media/f1.625ce6c0.jpeg";